if (!Element.prototype.checkVisibility) {
  Element.prototype.checkVisibility = function (options: any = {}) {
    const {
      checkOpacity = false,
      checkVisibilityCSS = false,
      checkDisplay = false,
      checkSize = false,
      checkViewport = false,
    } = options;

    // eslint-disable-next-line
    const el = this;

    // ❌ 不在 DOM 中
    if (!el.isConnected) return false;

    const style = window.getComputedStyle(el);

    // 1️⃣ display
    if (checkDisplay && style.display === 'none') {
      return false;
    }

    // 2️⃣ visibility
    if (checkVisibilityCSS && style.visibility !== 'visible') {
      return false;
    }

    // 3️⃣ opacity
    if (checkOpacity && parseFloat(style.opacity) === 0) {
      return false;
    }

    // 4️⃣ size
    if (checkSize) {
      const rect = el.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) {
        return false;
      }
    }

    // 5️⃣ viewport
    if (checkViewport) {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const vw = window.innerWidth;

      const inViewport =
        rect.bottom > 0 && rect.right > 0 && rect.top < vh && rect.left < vw;

      if (!inViewport) {
        return false;
      }
    }

    // 默认行为（类似浏览器默认）
    if (!checkDisplay && style.display === 'none') return false;
    if (!checkVisibilityCSS && style.visibility === 'hidden') return false;

    return true;
  };
}
